import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { LINEUP_PADDING } from '..'

type KickoffLineProps = {
    height: number
    width: number
}

const KickoffLine: FC<KickoffLineProps> = ({ height, width }) => (
    <Grid
        position="absolute"
        top={height / 2}
        left={LINEUP_PADDING}
        right={LINEUP_PADDING}
        height={2}
        width={width - LINEUP_PADDING * 2}
        backgroundColor="WHITE"
    />
)

export default KickoffLine
